import { SxProps, Theme } from '@mui/material/styles';
import colors from './colors';

// Define reusable styles as objects
export const contentBoxStyle: SxProps<Theme> = {
  width: "auto",
  height: "100%",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  flexDirection: "column",
  paddingX: "3rem",
  color: colors.warmBeige,
  backgroundColor: colors.lightgray,
};

export const imageContainerStyle: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",                // 1 item per row on extra small screens
    sm: "repeat(2, 1fr)",     // 2 items per row on small screens
    md: "repeat(3, 1fr)",     // 3 items per row on medium and larger screens
  },
  justifyContent: "center",
  gap: "2rem",
  padding: "2rem 0rem 10rem 0rem",
};

// You can add more reusable styles here
